var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "sidebar sidebar-offcanvas", attrs: { id: "sidebar" } },
    [
      _c(
        "ul",
        { staticClass: "nav" },
        [
          _c("li", { staticClass: "nav-item nav-profile" }, [
            _vm.$store.getters.user !== null
              ? _c(
                  "a",
                  {
                    staticClass: "cursor-pointer noselect nav-link",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ name: "account.info" })
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "nav-profile-text d-flex flex-column ellipsis ml-0"
                      },
                      [
                        _c("div", { staticClass: "mb-2" }, [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.$store.getters.user.first_name))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "font-weight-bold",
                              class: { "d-block": _vm.longName }
                            },
                            [_vm._v(_vm._s(_vm.$store.getters.user.last_name))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(_vm.getGreeting))
                        ])
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._l(_vm.sidebarLinks, function(link) {
            return _vm.canSeeLink(link)
              ? _c(
                  "li",
                  {
                    staticClass: "nav-item",
                    class: { active: _vm.isActive(link) }
                  },
                  [
                    typeof link.items === "undefined" || !link.items.length
                      ? _c(
                          "div",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "nav-link btn btn-outline-dark btn-block mb-3 pl-3 pr-1",
                                attrs: {
                                  tag: "a",
                                  to: { name: link.routeName }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "menu-title oswald" },
                                  [_vm._v(_vm._s(link.label))]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _c("div", [
                          _c(
                            "a",
                            {
                              staticClass:
                                "nav-link cursor-pointer btn btn-outline-dark mb-3 pl-3 pr-1",
                              on: {
                                click: function($event) {
                                  link.show =
                                    typeof link.show === "undefined"
                                      ? true
                                      : !link.show
                                  typeof link.routeDef === "undefined"
                                    ? null
                                    : _vm.$router.push(link.routeDef)
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "menu-title oswald" }, [
                                _vm._v(_vm._s(link.label))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse",
                              class: {
                                show:
                                  typeof link.show !== "undefined" && link.show
                              }
                            },
                            [
                              _c(
                                "ul",
                                { staticClass: "nav flex-column sub-menu" },
                                _vm._l(link.items, function(subItem) {
                                  return _c(
                                    "li",
                                    { staticClass: "nav-item cursor-pointer" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "nav-link oswald",
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push(
                                                subItem.routeDef
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(subItem.label) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ])
                  ]
                )
              : _vm._e()
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }